module.exports = __webpack_public_path__ + "static/shifting-gears-to-drive-a0bb6898d85fcc29fe711f76f47f9977.jpg";